function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M245.929,0.001C110.106,0.001,0,110.106,0,245.929s110.106,245.928,245.929,245.928 c54.538,0,104.919-17.764,145.702-47.806c-2.169-0.146-4.286-1.097-5.853-2.847l-40.28-45.014l-21.693,33.293l-17.911-90.492 l92.117,28.655l-39.651,17.035l40.28,45.016c1.869,2.086,2.503,4.825,2.012,7.378c55.635-45.087,91.206-113.957,91.206-191.147 C491.858,110.106,381.752,0.001,245.929,0.001z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var _ref25 =
/*#__PURE__*/
React.createElement("g", null);

var _ref26 =
/*#__PURE__*/
React.createElement("g", null);

var _ref27 =
/*#__PURE__*/
React.createElement("g", null);

var _ref28 =
/*#__PURE__*/
React.createElement("g", null);

var _ref29 =
/*#__PURE__*/
React.createElement("g", null);

var _ref30 =
/*#__PURE__*/
React.createElement("g", null);

var _ref31 =
/*#__PURE__*/
React.createElement("g", null);

var _ref32 =
/*#__PURE__*/
React.createElement("g", null);

var SvgWeb = function SvgWeb(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.858 491.858",
    style: {
      enableBackground: "new 0 0 491.858 491.858"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, _ref2, React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M91.849,263.346l2.255,12.53l0.25,0.084l2.757-12.614l18.21-57.806h12.53l18.211,57.806 l2.924,13.7h0.25l2.84-13.7l14.619-57.806h15.371l-26.23,90.385h-12.531l-17.876-55.718l-3.926-16.123h-0.25l-3.759,16.123 l-17.542,55.718H87.338l-26.23-90.385h15.454L91.849,263.346z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M221.329,263.346l2.255,12.53l0.25,0.084l2.757-12.614l18.21-57.806h12.531l18.211,57.806 l2.922,13.7h0.252l2.84-13.7l14.619-57.806h15.369l-26.229,90.385h-12.531l-17.877-55.718l-3.926-16.123h-0.25l-3.76,16.123 l-17.542,55.718h-12.614l-26.23-90.385h15.454L221.329,263.346z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.809,263.346l2.255,12.53l0.251,0.084l2.757-12.614l18.211-57.806h12.53l18.211,57.806 l2.923,13.7h0.251l2.84-13.7l14.619-57.806h15.37l-26.229,90.385h-12.53l-17.877-55.718l-3.926-16.123h-0.251l-3.759,16.123 l-17.543,55.718h-12.613l-26.23-90.385h15.454L350.809,263.346z"
  })))), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17), _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/web.ba8b1e9d.svg";
export { ForwardRef as ReactComponent };